<script>
import MenuRow from '@/components/molecules/MenuRow'

export default {
    name: 'StoreBlock',

    components: { MenuRow },

    props: {
        // { store: {id, name}, items: [rows], distance: Number|null }
        group: {
            type: Object,
            required: true,
        },
        nearest: Boolean,
        delay: Boolean,
    },
}
</script>

<template lang="pug">
.store-block
    .store-block-head
        h3.store-block-name {{ group.store.name }}
        span.store-block-nearest(v-if="nearest && group.distance != null") {{ $t('brand.nearest') }} · {{ group.distance }} km
        span.store-block-distance.text-73(v-else-if="group.distance != null") {{ group.distance }} km
    .store-block-menus
        menu-row(v-for="item in group.items" :key="item.id" :model="item" :delay="delay")
</template>
